export const THEME_MODES = ['light', 'dark', 'system'] as const
export type ThemeMode = (typeof THEME_MODES)[number]

/** Ключ в localStorage. Тот же ключ читает inline-скрипт в index.html. */
export const THEME_STORAGE_KEY = 'app-theme'

export function isThemeMode(value: unknown): value is ThemeMode {
  return typeof value === 'string' && (THEME_MODES as readonly string[]).includes(value)
}

/** Тёмная ли тема для выбранного режима и системной настройки. */
export function resolveIsDark(mode: ThemeMode, systemPrefersDark: boolean): boolean {
  if (mode === 'dark') return true
  if (mode === 'light') return false
  return systemPrefersDark
}

/** localStorage или null, если браузер его не даёт (приватный режим, запрет cookies). */
export function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

/** Сохранённый режим; при любой проблеме — 'system'. */
export function readStoredThemeMode(storage: Pick<Storage, 'getItem'> | null): ThemeMode {
  if (!storage) return 'system'
  try {
    const raw = storage.getItem(THEME_STORAGE_KEY)
    return isThemeMode(raw) ? raw : 'system'
  } catch {
    return 'system'
  }
}

/** Сохраняет режим. false — сохранить не удалось, режим проживёт до перезагрузки. */
export function writeStoredThemeMode(storage: Pick<Storage, 'setItem'> | null, mode: ThemeMode): boolean {
  if (!storage) return false
  try {
    storage.setItem(THEME_STORAGE_KEY, mode)
    return true
  } catch {
    return false
  }
}
